module.exports = __webpack_public_path__ + "static/media/3DPPA41.b726f2ef.jpg";